import axios from 'axios'
import router from '../router'
import _config from '../config/index'
export default {
    request (method, url, data, params, headers = null) {
        if (!method) {
            console.error('API function call requires method argument')
            return
        }

        if (!url) {
            console.error('API function call requires uri argument')
            return
        }
        let http = _config.developerApiDomain
        // let httpBody = 'uat-api.nuwarobotics.com/'
        let httpBott = '/v1'
        let token = localStorage.getItem('token')
        let header = null
        if (token && token !== 'null') {
            header = { authorization: token }
        }
        let instance = axios.create({
            method: 'get',
            url: '',
            data: {},
            params: {},
            headers: header,
            baseURL: `${http}${httpBott}`,
            timeout: 50000
        })
        // 添加一个请求拦截器
        instance.interceptors.request.use(function (config) {
            // Do something before request is sent
            // console.log('req', config)
            return config
        }, function (error) {
            // console.log('req', error)
            // Do something with request error
            return Promise.reject(error)
        })
        // 添加一个响应拦截器
        instance.interceptors.response.use(function (response) {
            // Do something with response data
            if (response.data) {
                // console.log(response.data)
            }
            return response
        }, function (error) {
            // console.log(error)
            if (error.response) {
                // 判断token是无效或者过期
                if (error.response.data.error === '96012') {
                    localStorage.removeItem('token')
                    sessionStorage.removeItem('registeredDetail')
                    router.push({
                        name: 'userLogin' // 到登录页重新获取token
                    })
                }
            } else if (error.request) {
                // 发送请求但是没有响应返回
                // console.log(error.request)
            } else {
                // 其他错误
                // console.log('Error', error.message)
            }
            // console.log(error.config)
            return Promise.reject(error)
        })
        // return instance.request
        return instance({ method, url, data, params, headers })
    }
}
